/** @flow */

import { beginRequest, completeRequest } from "@store/utils";
import type { EmployeeIdentityState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetEmployeeIdentityData = (state: EmployeeIdentityState) => () =>
  startRequest(state);

export const onGetEmployeeIdentityDataSuccess = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  employeeIdentityData: payload,
});

export const onGetEmployeeIdentityDataError = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetEmployeeIdentityDataEffective = (state: EmployeeIdentityState) => () =>
  startRequest(state);

export const onGetEmployeeIdentityDataEffectiveSuccess = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  employeeIdentityData: {
    ...state.employeeIdentityData,
    ...payload,
  },
});

export const onGetEmployeeIdentityDataEffectiveError = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetEmployeeIdentityChangeSet = (state: EmployeeIdentityState) => () =>
  startRequest(state);

export const onGetEmployeeIdentityChangeSetSuccess = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  changeSet: payload,
});

export const onGetEmployeeIdentityChangeSetError = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onUpdatePlatformDataSecurityEmployeeIdentity = (state: EmployeeIdentityState) => () =>
  startRequest(state);

export const onUpdatePlatformDataSecurityEmployeeIdentitySuccess = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  employeeIdentityData: payload,
});

export const onUpdatePlatformDataSecurityEmployeeIdentityError = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetPlatformDataSecurityEmployeeIdentitySchema = (
  state: EmployeeIdentityState,
) => () => startRequest(state);

export const onGetPlatformDataSecurityEmployeeIdentitySchemaSuccess = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetPlatformDataSecurityEmployeeIdentitySchemaError = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onSetEmployeeIdentityMainOptionsModalVisibility = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    mainOptions: {
      ...state.modals.mainOptions,
      visible: payload,
    },
  },
});

export const onSetEmployeeIdentitySecurityQuestionsModalVisibility = (
  state: EmployeeIdentityState,
) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    securityQuestions: {
      ...state.modals.securityQuestions,
      visible: payload,
    },
  },
});

export const onSetEmployeeIdentityAccessAuditModalVisibility = (state: EmployeeIdentityState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    accessAudit: {
      ...state.modals.accessAudit,
      visible: payload,
    },
  },
});
